import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import infiniteScroll from 'vue-infinite-scroll'
import GoogleAuth from './vue-google-auth'
import ElementUI, { Loading, Message } from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import mixin from './mixin'
import App from './components/App'
import store from './store'
import axios from './store/my-axios'
import config from '../config'

import 'regenerator-runtime/runtime';

Vue.use(ElementUI, { locale });
Vue.use(infiniteScroll);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$axios = axios;
Vue.prototype.apiUrl = config.getApiUrl();

store.state.accountId = (store.getPayload() || {}).companyId || '5ab988a9032ca100221c1cca';

window.addEventListener('onCompanyChange', async (e) => {
  console.log('onCompanyChange', e.companyId);
  store.state.accountId = e.companyId;
  router.push({ name: 'Dashboard'});
  store.dispatch('loadForms');
}, false);

sync(store, router);

Vue.mixin(mixin);

Vue.use(GoogleAuth, {
  client_id: '527279504416-3p7toklagvpicrrm43moita45s54hrpg.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/analytics ' +
  'https://www.googleapis.com/auth/analytics.readonly ' +
  'https://www.googleapis.com/auth/plus.me '
});
Vue.googleAuth().load();

export function createApp() {
  return new Vue({
    router,
    store,
    ...App,
    mounted: () => {
    }
  });
}

export { router, store }



// WEBPACK FOOTER //
// ./client/app.js